(function(angular){
	'use strict';
	
	var portfolioAllocationByReitChartObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			defaultReitId: '<?',
			reitElements: '<',
			reitElementModeOnly: '<?',
			ratingAllocations: '<',
			totalAccountValue: '=?'
		},
		controller: [
			'$rootScope',
			'$q',
			'$scope',
			'$timeout',
			'INVESTMENT_ENTITY_ID',
			'localStorageFactory',
			'mixpanelFactory',
			'PortfolioAllocationChartService',
			'urlFactory',
			PortfolioAllocationByReitChartFunction
		],
		controllerAs: 'portfolioAllocationByReitChart'
	};
	
	angular
		.module('portfolioAllocationChartModule')
		.component('portfolioAllocationByReitChart', portfolioAllocationByReitChartObject);
	
	function templateUrlFunction(STATIC_BASE_PATH) {
		return STATIC_BASE_PATH + '/static/html/shared/charts/portfolio-allocation/portfolio-allocation-by-reit-chart.html';
	}
	
	function PortfolioAllocationByReitChartFunction(
		$rootScope,
		$q,
		$scope,
		$timeout,
		INVESTMENT_ENTITY_ID,
		localStorageFactory,
		mixpanelFactory,
		PortfolioAllocationChartService,
		urlFactory){
		var portfolioAllocationByReitChart = this;
		var defaultViewMode = 'PROJECT';
		var hoverDelayMillis = 100;
		var viewModeKey = 'com.fundrise.dashboard.portfolioAllocationByReitChart.viewMode';

		var chartOptions = {
			chart: {
				type: 'pie',
				spacing: [0,0,0,0]
			},
			plotOptions: {
				series: {
					animation: false,
					borderColor: '#f6f8f9',
					cursor: 'pointer',
					states: {
						hover: {
							enabled: true
						}						
					}
				}
			}
		};

		function setActiveReit(reitId) {

			var activeReit;

			if(angular.isDefined(reitId) && angular.isDefined(portfolioAllocationByReitChart.chartReference)) {
				angular.forEach(portfolioAllocationByReitChart.reitSeriesObj.data, function(reit) {
					if(parseInt(reitId) === parseInt(reit.reitId)) {
						activeReit = reit;
					}
				});
			}

			$scope.$applyAsync(function() {
				portfolioAllocationByReitChart.activeReit = activeReit;
			});
		}

		function setActiveReitElement(reitElement) {

			$scope.$applyAsync(function() {
				portfolioAllocationByReitChart.activeReitElement = reitElement;
			});			
		}

		function setActiveRating(ratingObj) {
			$scope.$applyAsync(function() {
				portfolioAllocationByReitChart.activeRating = ratingObj;
			});			
		}

		function clearActive() {

			var clearActive = $timeout(function() {

				$scope.$applyAsync(function() {
					delete portfolioAllocationByReitChart.activeReitElement;

					if(angular.isDefined(portfolioAllocationByReitChart.defaultReitId)) {
						setActiveReit(portfolioAllocationByReitChart.defaultReitId);
					} else {
						delete portfolioAllocationByReitChart.activeReit;
					}

					if(!portfolioAllocationByReitChart.drilledDown || portfolioAllocationByReitChart.viewMode === 'REIT') {
						delete portfolioAllocationByReitChart.activeRating;
					}
				});
			}, hoverDelayMillis);

			$rootScope.$on('rating.mouseOver', function() {
				$timeout.cancel(clearActive);
			});
			$rootScope.$on('reitElement.mouseOver', function() {
				$timeout.cancel(clearActive);
			});
			$rootScope.$on('rating.drilldown', function() {
				$timeout.cancel(clearActive);
			});
			$rootScope.$on('reit.mouseOver', function(event, reitId) {
				$timeout.cancel(clearActive);
			});
		}

		function getTotalAccountValueFontSize(totalAccountValue) {
			var totalAccountValueFontSize;
			var figures = totalAccountValue.length - 3;
			var minAllowedFontSize = 24;
			var maxAllowedFontSize = 36;
			var minExpectedFigures = 3;
			var maxExpectedFigures = 7;
			var slope = (maxAllowedFontSize - minAllowedFontSize) / (maxExpectedFigures - minExpectedFigures);

			if(figures > maxExpectedFigures) {
				totalAccountValueFontSize = minAllowedFontSize;
			} else if(figures < minExpectedFigures) {
				totalAccountValueFontSize = maxAllowedFontSize;
			} else {
				totalAccountValueFontSize = ((maxExpectedFigures - figures) * slope) + minAllowedFontSize;
			}

			return totalAccountValueFontSize;
		}

		function getReitPositionData() {
			return urlFactory.apiGetPromise('/api-secured/investment-entity/' + INVESTMENT_ENTITY_ID + '/portfolio/positions-table')
				.then(function(response) {
					return response.data;
				});
		}

		function getViewMode() {
			var viewMode;
			if(portfolioAllocationByReitChart.reitElementModeOnly) {
				viewMode = 'PROJECT';
			} else {
				var viewModePreference = localStorageFactory.getItem(viewModeKey);
				if(viewModePreference) {
					viewMode = viewModePreference;
				} else {
					viewMode = defaultViewMode;
				}
			}
			return viewMode;
		}

		function initChart() {
			var seriesObj;
			if(portfolioAllocationByReitChart.viewMode === 'REIT') {
				chartOptions.series = [portfolioAllocationByReitChart.reitSeriesObj];

			} else if(portfolioAllocationByReitChart.viewMode === 'PROJECT' && angular.isDefined(portfolioAllocationByReitChart.defaultReitId)) {
				seriesObj = PortfolioAllocationChartService.getReitElementSeriesObj(portfolioAllocationByReitChart.reitElements);
				chartOptions.series = [seriesObj];

			} else {
				seriesObj = PortfolioAllocationChartService.getNestedSeriesObj(portfolioAllocationByReitChart.ratingAllocations);
				chartOptions.series = [seriesObj.parentSeries];
				chartOptions.drilldown = {
					series: seriesObj.childrenSeries
				};
				portfolioAllocationByReitChart.nestedSeriesObj = seriesObj;
			}

			portfolioAllocationByReitChart.chartOptions = chartOptions;
		}

		$rootScope.$on('rating.drilldown', function() {
			$scope.$applyAsync(function() {
				portfolioAllocationByReitChart.drilledDown = true;
			});

			mixpanelFactory.track('Portfolio Allocation Chart - Drilled Down');
		});

		$rootScope.$on('rating.mouseOver', function(event, ratingObj) {
			setActiveRating(ratingObj);
		});

		$rootScope.$on('rating.mouseOut', function() {
			clearActive();
		});

		$rootScope.$on('reit.mouseOver', function(event, reitId) {
			setActiveReit(reitId);
		});

		$rootScope.$on('reit.mouseOut', function(event) {
			clearActive();
		});

		$rootScope.$on('reitElement.mouseOver', function(event, reitElement) {
			setActiveReitElement(reitElement);
		});

		$rootScope.$on('reitElement.mouseOut', function(event) {
			clearActive();
		});

		$scope.$on('highchart.load', function(event, chart) {
			portfolioAllocationByReitChart.chartReference = chart;

			if(portfolioAllocationByReitChart.defaultReitId) {
				$rootScope.$broadcast('reit.mouseOver', portfolioAllocationByReitChart.defaultReitId);
			}
		});

		portfolioAllocationByReitChart.drillUp = function() {
			portfolioAllocationByReitChart.chartReference.drillUp();
			portfolioAllocationByReitChart.drilledDown = false;
			delete portfolioAllocationByReitChart.activeRating;

			mixpanelFactory.track('Portfolio Allocation Chart - Drilled Up');
		};

		portfolioAllocationByReitChart.setViewMode = function(viewMode) {
			var seriesObj;
			portfolioAllocationByReitChart.viewMode = viewMode;
			localStorageFactory.setItem(viewModeKey, viewMode);
			clearActive();

			if(viewMode === 'REIT') {
				portfolioAllocationByReitChart.chartReference.series[0].update(portfolioAllocationByReitChart.reitSeriesObj);

			} else if(portfolioAllocationByReitChart.viewMode === 'PROJECT' && angular.isDefined(portfolioAllocationByReitChart.defaultReitId)) {
				seriesObj = PortfolioAllocationChartService.getReitElementSeriesObj(portfolioAllocationByReitChart.reitElements);
				portfolioAllocationByReitChart.chartReference.series[0].update(seriesObj);

			} else {
				if(angular.isDefined(portfolioAllocationByReitChart.nestedSeriesObj)) {
					seriesObj = portfolioAllocationByReitChart.nestedSeriesObj;
				} else {
					seriesObj = PortfolioAllocationChartService.getNestedSeriesObj(portfolioAllocationByReitChart.ratingAllocations);
				}
				portfolioAllocationByReitChart.chartReference.update({
					drilldown: {
						series: seriesObj.childrenSeries
					}
				}, false);
				portfolioAllocationByReitChart.chartReference.series[0].update(seriesObj.parentSeries);
			}

			mixpanelFactory.track('Portfolio Allocation Chart - Set View Mode', {
				'View Mode': viewMode
			});
		};

		portfolioAllocationByReitChart.$onChanges = function(changeObj) {

			portfolioAllocationByReitChart.viewMode = getViewMode();

			var needsReitPositionData = !angular.isDefined(portfolioAllocationByReitChart.reitPositionData) && !portfolioAllocationByReitChart.reitElementModeOnly;

			if(needsReitPositionData) {
				getReitPositionData().then(function(reitPositionData) {
					portfolioAllocationByReitChart.reitPositionData = reitPositionData;
					portfolioAllocationByReitChart.totalAccountValue = reitPositionData.totalAccountValue;
					portfolioAllocationByReitChart.totalAccountValueFontSize = getTotalAccountValueFontSize(reitPositionData.totalAccountValue);
					portfolioAllocationByReitChart.reitSeriesObj = PortfolioAllocationChartService.getReitSeriesObj(portfolioAllocationByReitChart.reitPositionData, portfolioAllocationByReitChart.defaultReitId);

					initChart();
				});
			} else {
				initChart();
			}
		};
	}
})(window.angular);